module.exports = __webpack_public_path__ + "static/media/red_stress_EN.6b287e38.png";